import React, { useEffect, memo, useRef } from 'react';
import { useIsOnScreen } from '@yme/hooks/index';
import { ContainerStyled } from './styled';
export const InfiniteScroll = memo(({ children, onReachEnd, offset = '0px', containerStyles }) => {
    const containerRef = useRef({});
    // to make onReachEnd callback non-reactive
    const onReachEndRef = useRef(onReachEnd);
    const { isOnScreen, ref: endElementRef } = useIsOnScreen(0, offset);
    useEffect(() => {
        onReachEndRef.current = onReachEnd;
    }, [onReachEnd]);
    useEffect(() => {
        const { height } = containerRef.current.getBoundingClientRect();
        if (height > 0 && isOnScreen) {
            onReachEndRef.current();
        }
    }, [isOnScreen]);
    return (React.createElement(ContainerStyled, { ref: containerRef, styles: containerStyles },
        children,
        React.createElement("div", { ref: endElementRef })));
});
InfiniteScroll.displayName = 'InfiniteScroll';
